import { SDrawerOrModal, SGeneralForms, SLowcodeList, SMessage, SSkuCard } from 'shj-components'
import styles from '../../index.module.less'
import { useFileUrlPrefix } from 'shj-utils'
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
  deleteQuoteBudgetDtl,
  getDtlRefType,
  getListBudgetDtl,
  listProductSkuRelationSpuFormat,
  updateBudgetField,
  updateDynaOptions,
  updateMaterialDynaOptions,
  updatePackDtl,
} from '@/services/order'
import { isArray, isEmpty } from 'lodash-es'
import { shortageConfig } from '../../quoteSelection/config'
import { Button, Divider, message, Spin, Tooltip } from 'antd'
import ModifyStandard from '../../components/modifyStandard'
import KitDetailDialogV3 from '../../components/KitDetailDialogV3'
import SkuDynamic from '@/pages/orderServiceSpaceChoose/components/SkuDynamic'

export default function ReQuoteSelection(props: any) {
  const { refItemId } = props
  const tableRef = useRef()
  const fileUrlPrefix = useFileUrlPrefix()
  const navigate = useNavigate()
  const { budgetId } = useParams() // 报价id
  const [modifyStandardOpen, setModifyStandardOpen] = useState(false)
  const [modifyLoading, setModifyLoading] = useState<boolean>(false) // 修改规格loading
  const [recordItem, setRecordItem] = useState<any>(null) // 预算量计算式弹窗记录当前行数据
  const [currentModifyStandardArray, setCurrentModifyStandardArray] = useState<any>([]) // 当前修改规格数组
  const [budgetQtyFormularOpen, setBudgetQtyFormularOpen] = useState(false) // 预算量计算式弹窗
  const [qtyFormularLoading, setQtyFormularLoading] = useState(false) // 预算量计算式loading
  const [skuList, setSkuList] = useState<any>([]) // 当前产品的sku map信息
  // 套件选择
  const [kitSku, setKitSku] = useState<any>({})
  const [kitSpu, setKitSpu] = useState<any>({})
  const [openKitDialog, setOpenKitDialog] = useState(false)
  const [combinationInfoList, setCombinationInfoList] = useState<any[]>([])
  const budgetQtyFormularRef = useRef<any>(null)
  const [recordInfo, setRecordInfo] = useState<any>(null) // 预算量计算式弹窗记录当前行数据
  const [packDtlList, setPackDtlList] = useState<any[]>([])
  const [selectType, setSelectType] = useState('') // 选择类型
  const [kitLoading, setKitLoading] = useState(false)
  const [activityInfo, setActivityInfo] = useState<any>({})
  const [loading, setLoading] = useState(false)

  // 动态属性
  const [skuDynamicOpen, setSkuDynamicOpen] = useState(false) // 动态属性弹窗
  const [skuDynamicVoList, setSkuDynamicVoList] = useState<any>([]) // 报价属性表单数据

  const onBudgetQtyFormularRef = () => {
    const { onFormRef } = budgetQtyFormularRef.current || {}
    return onFormRef?.()
  }
  const [tableConfig, setTableConfig] = useState<any>({
    ...shortageConfig,
  })

  const tagsMap = {
    NATIONAL_UPPLEMENT: 'nationalCss',
  }
  // useEffect(() => {
  //   summaryAmountFlagRef.current = summaryAmountShowFlag
  // }, [summaryAmountShowFlag])

  useEffect(() => {
    getDtlRefType({
      params: {
        budgetId: budgetId,
      },
    }).then(res => {
      if (isArray(res)) {
        fetchList()
        setTableConfig({
          ...tableConfig,
          footer: res.map((item: any) => {
            let obj = {
              GENERAL: {
                label: '新增标配',
                events: ['onClick:onAddStandard'],
              },
              ADD: {
                label: '新增增项',
                events: ['onClick:onAddAdditional'],
              },
              ACTIVITY: {
                label: '新增优惠',
                events: ['onClick:onAddDiscount'],
              },
            }
            return {
              label: obj[item].label,
              type: 'primary',
              ghost: true,
              events: obj[item].events,
            }
          }),
        })
      }
    })
  }, [])

  const onAdd = (type: string) => {
    /**
     * @budgetId 报价id
     * @generalItemManageId 通项id 如果没有则为空
     * @refItemId 当前选择项目id
     */
    console.log(type)
    if (type === 'GENERAL') {
      // record.generalItemManageId = record.generalItemManageId ? record.generalItemManageId : ''
      navigate(
        `/order/list/details/quote-selection/selecting-materials/${budgetId}/${refItemId}/${type}/?generalItemManageId=${''}`
      )
    } else {
      navigate(
        `/order/list/details/quote-selection/selecting-materials/${budgetId}/${refItemId}/${type}`
      )
    }
  }
  const fetchList = () => {
    setLoading(true)
    try {
      return new Promise(async (resolve, reject) => {
        let resData: any = await getListBudgetDtl({
          id: budgetId,
          params: {
            refItemId: refItemId,
          },
        })
        resData = resData.map((item: any, index) => {
          return {
            ...item,
            orderSeq: index + 1,
          }
        })
        setLoading(false)
        tableRef.current?.updateDataSource(resData)
      })
    } catch {
      setLoading(false)
    }
  }
  // 修改产品规格
  const handleEditDynamicProperties = async (record: any, item?: any) => {
    setModifyStandardOpen(true)
    setModifyLoading(true)
    setRecordItem(item)
    setRecordInfo(record)
    let dynaOptions
    let resData
    try {
      resData = await listProductSkuRelationSpuFormat({
        data: {
          quoteBudgetId: budgetId,
          productSpuId: item.prdId,
          generalId:
            item.refType === 'UP_DOWN' || item.refType === 'GENERAL'
              ? record?.generalItemManageId || null
              : null,
          priceCalcType: item.refType === 'UP_DOWN' ? 'CHANGE_LEVEL' : null,
          activityProductId: record?.refActiveDtlId || null,
        },
      })
    } catch {
      setModifyLoading(false)
    }
    setModifyLoading(false)
    dynaOptions = item.dynaOptions
    setSkuList(resData.skuList)
    resData.specificationArgList?.map((item: any) => {
      if (!isEmpty(dynaOptions)) {
        item.argValId = dynaOptions[item.argCode].valueId
        item.argValName = dynaOptions[item.argCode].valueName
      }
      item.options = item.values?.map((ol: any) => {
        return {
          ...ol,
          argValId: ol.valueId,
          argValName: ol.valueName,
        }
      })
      return item
    })
    setCurrentModifyStandardArray(resData.specificationArgList || [])
  }
  // 删除产品
  const deleteSku = id => {
    SMessage.confirm({
      onOk: () => {
        if (id) {
          return deleteQuoteBudgetDtl({
            params: {
              id,
            },
          }).then((res: any) => {
            message.success(res.message || '操作成功')
            fetchList()
          })
        }
      },
    })
  }
  // 确认规格回调
  const onSubmitModifyStandard = async value => {
    let selectObj = {}
    value.forEach((item: any) => {
      selectObj[item.argCode] = {
        argValId: item.argValId,
        argValName: item.argValName,
      }
    })
    let skuId: string = ''
    // 确定sku
    skuList.forEach((item: any) => {
      let flag = true
      for (let key in selectObj) {
        if (item.argMap[key].valueId !== selectObj[key].argValId) {
          flag = false
        }
      }
      if (flag) {
        skuId = item.id
      }
    })
    // 选材之后确定SKU码
    await updateDynaOptions({
      data: {
        quoteBudgetId: budgetId,
        quoteBudgetDtlId: recordItem.id,
        productSkuId: skuId,
        // dynaOptions: JSON.stringify(value || []),
      },
    })
    setModifyStandardOpen(false)
    fetchList()
  }
  // 预算量计算式
  const handleEditBudgetQtyFormular = async (record: any, item?: any) => {
    setRecordItem(item)
    setBudgetQtyFormularOpen(true)
    onBudgetQtyFormularRef().setFieldsValue({
      remark: item.remark,
      budgetQtyFormular: item.standardFlag ? item.auditStandardQtyFormular : item.budgetQtyFormular,
    })
  }

  const onBudgetQtyFormularSubmit = async value => {
    setQtyFormularLoading(true)
    updateBudgetField({
      data: {
        id: recordItem.id,
        ...onBudgetQtyFormularRef().getFieldsValue(),
      },
    })
      .then(res => {
        setBudgetQtyFormularOpen(false)
        fetchList()
      })
      .finally(() => {
        setQtyFormularLoading(false)
      })
  }
  // 套件
  const handleKitDetail = async (record: any, item) => {
    console.log(item, 'item')
    console.log(record, 'record')
    setOpenKitDialog(true)
    setKitLoading(true)
    setRecordItem(item)
    setRecordInfo(record)
    setKitSku({})
    setKitSpu({})
    setSelectType(item.refType)
    try {
      let resData: any = await listProductSkuRelationSpuFormat({
        data: {
          quoteBudgetId: budgetId,
          budgetDtlId: item.id,
          productSkuId: item.prdSkuId,
          productSpuId: item.prdId,
          generalId:
            item.refType === 'UP_DOWN' || item.refType === 'GENERAL'
              ? record?.generalItemManageId || null
              : null,
          priceCalcType: item.refType === 'UP_DOWN' ? 'CHANGE_LEVEL' : null,
          activityProductId: record?.refActiveDtlId || null,
        },
      })
      let skuInfo = resData?.skuList?.find(el => el.id === item.prdSkuId) || []
      setKitSku(skuInfo)
      setKitSpu(resData)
      if (item.refType === 'ACTIVITY') {
        setActivityInfo({
          activityId: item.refActiveId,
          activityProductId: item.refActiveDtlId,
        })
      }
      setPackDtlList(item.packDtlList || [])
      setKitLoading(false)
    } catch (error) {
      setKitLoading(false)
    }
  }
  const closeKitDialog = (value: any) => {
    setOpenKitDialog(false)
  }
  const confirmInfo = (combinationInfoDetail: any, combinationPrice) => {
    // 更新packDtl
    updatePackDtl({
      data: {
        budgetDtlId: recordItem.id,
        packDtlList: combinationInfoDetail.filter(el => el.selectSkuId && el.checked),
      },
    }).then(res => {
      message.success('更新成功')
      fetchList()
    })
  }

  // 修改报价属性
  const handleEditSkuDynamicVoList = (record: any, item?: any) => {
    setSkuDynamicOpen(true)
    let skuDynamicVoList = item.skuDynamicVoList.map(el => {
      let materialDynaOptions = item.materialDynaOptions?.find(item => item.id === el.id) || null
      if (materialDynaOptions) {
        el.optionId = materialDynaOptions.optionId
        el.optionName = materialDynaOptions.optionName
      }
      return el
    })
    setRecordItem(item)
    setSkuDynamicVoList(skuDynamicVoList)
  }
  const onSubmitSkuDynamicVoList = async value => {
    // 更新动态属性
    updateMaterialDynaOptions({
      data: {
        budgetDtlId: recordItem.id,
        materialDynaOptions: value,
      },
    }).then(res => {
      message.success('更新成功')
      fetchList()
    })
  }
  const showNationalTagRender = (item: any) => {
    if (item?.showTags && isArray(item?.showTags)) {
      return item.showTags?.map((tag: any) => {
        return (
          <div className={tagsMap[tag.tagCode]}>
            <Tooltip title={tag.tagName}>{tag.tagName}</Tooltip>
          </div>
        )
      })
    } else {
      return <></>
    }
  }

  const extension = {
    request: {},
    pagination: false,
    status: {},
    events: {
      onAddStandard: () => onAdd('GENERAL'),
      onAddAdditional: () => onAdd('ADD'),
      onAddDiscount: () => onAdd('ACTIVITY'),
    },
    customRender: {
      actionRender: (text: any, record: any) => {
        return (
          <Button
            // disabled={!couldOperate}
            color="primary"
            variant="outlined"
            danger
            onClick={() => {
              // if (selectType !== 'SUB') {
              deleteSku(record.budgetDtlVoList[0]?.id)
              // }
            }}
          >
            删除
          </Button>
        )
      },
      renderSku: (text: any, record: any) => {
        const list = record?.budgetDtlVoList || []
        if (isArray(list) && !!list?.length) {
          return list.map((item, index) => {
            return (
              <>
                {index != 0 && (
                  <Divider
                    style={{ margin: '4px 0', borderBlockStart: '1px dashed rgba(5, 5, 5, 0.06)' }}
                  />
                )}
                <SSkuCard
                  key={index + '-' + record?.id + '-' + item?.id + '-' + item.prdSkuId}
                  width={'100%'}
                  url={
                    item?.mainPic
                      ? item.mainPic.startsWith('http')
                        ? item.mainPic
                        : fileUrlPrefix + item.mainPic
                      : 'https://static.shjmall.cn/sass/empty.png'
                  }
                  urlList={item?.imageUrls}
                  title={
                    <div
                      style={{
                        // color: item?.dynaOptionsWarn == true ? 'red' : 'black',
                        width: '100%',
                      }}
                      className={styles.skuTitle}
                    >
                      {showNationalTagRender(item)}
                      {item.name}
                    </div>
                  }
                  imgFit={false}
                  desc={<span className={styles.skuDesc}>{item.prdSkuId}</span>}
                  imgFilter={
                    item?.skuWarnMessage ? (
                      <div dangerouslySetInnerHTML={{ __html: item?.skuWarnMessage }} />
                    ) : undefined
                  }
                  disabled={item?.skuWarnMessage}
                  operation={() => (
                    <>
                      {!(
                        item?.presetFlag &&
                        !item?.generalItemManageId &&
                        !item?.refGeneralItemManageId
                      ) && (
                        <Button
                          disabled={!item.deletedFlag}
                          size="small"
                          danger
                          onClick={() => {
                            deleteSku(item.id)
                          }}
                        >
                          删除
                        </Button>
                      )}
                      {item.refType !== 'SUB' && item.packDtlList && !!item.packDtlList.length && (
                        <Button
                          size="small"
                          type="primary"
                          ghost
                          onClick={() => handleKitDetail(record, item)}
                        >
                          产品明细
                        </Button>
                      )}
                      {item.refType !== 'SUB' && !item.templateFlag && item.chooseFormatFlag && (
                        <Button
                          size="small"
                          type="primary"
                          ghost
                          // disabled={!couldOperate}
                          onClick={() => handleEditDynamicProperties(record, item)}
                        >
                          修改规格
                        </Button>
                      )}
                      {item.skuDynamicVoList && !!item.skuDynamicVoList.length && (
                        <Button
                          size="small"
                          type="primary"
                          ghost
                          onClick={() => handleEditSkuDynamicVoList(record, item)}
                        >
                          报价属性
                        </Button>
                      )}
                      <Button
                        size="small"
                        type="primary"
                        ghost
                        // disabled={!item.updateFormularFlag}
                        onClick={() => handleEditBudgetQtyFormular(record, item)}
                      >
                        预算量
                      </Button>
                    </>
                  )}
                />
              </>
            )
          })
        }
      },
      // typeRender: (text: any, record: any) => {
      //   const list = record?.budgetDtlVoList || []
      //   let typeName = {
      //     ADD: '增项',
      //     ACTIVITY: '优惠',
      //     GENERAL: '通项选材',
      //     PROJECT: '项目选材',
      //     SUB: '减项',
      //     UP_DOWN: '升降级',
      //   }
      //   if (isArray(list) && !!list?.length) {
      //     return list.map((item, index) => {
      //       return typeName[item.sourceRefType] ? typeName[item.sourceRefType] : '其他'
      //     })
      //   }
      // },
      // displayQtyValueRender: (text: any, record: any) => {
      //   const list = record?.budgetDtlVoList || []
      //   if (isArray(list) && !!list?.length) {
      //     return list.map((item, index) => {
      //       return item.displayQtyValue < 0 ? -1 * item.displayQtyValue : item.displayQtyValue
      //     })
      //   }
      // },
      // budgetAmountRender: (text: any, record: any) => {
      //   const list = record?.budgetDtlVoList || []
      //   if (isArray(list) && !!list?.length) {
      //     return list.map((item, index) => {
      //       return item.budgetAmount < 0 ? -1 * item.budgetAmount : item.budgetAmount
      //     })
      //   }
      // },
    },
  }

  return (
    <Spin spinning={loading}>
      <SLowcodeList config={tableConfig} ref={tableRef} {...extension} />
      {/* 修改规格 */}
      <ModifyStandard
        open={modifyStandardOpen}
        onCancel={() => {
          setModifyStandardOpen(false)
        }}
        loading={modifyLoading}
        formList={currentModifyStandardArray}
        title="选择规格"
        onSubmit={onSubmitModifyStandard}
        skuList={skuList}
        okText="确定"
        
      ></ModifyStandard>
      {/* 产品明细 */}
      {openKitDialog && (
        <KitDetailDialogV3
          kitSku={kitSku}
          setKitSku={setKitSku}
          productInfo={kitSpu}
          open={openKitDialog}
          closeDialog={closeKitDialog}
          confirmInfo={confirmInfo}
          combinationInfoList={combinationInfoList}
          packDtlList={packDtlList}
          selectType={selectType}
          activityInfo={activityInfo}
          generalId={recordInfo.generalItemManageId}
          recordItem={recordItem}
        />
      )}
      {/* 动态属性 */}
      <SkuDynamic
        open={skuDynamicOpen}
        onCancel={() => {
          setSkuDynamicOpen(false)
        }}
        loading={false}
        formList={skuDynamicVoList}
        title="报价属性"
        onSubmit={onSubmitSkuDynamicVoList}
      ></SkuDynamic>
      <SDrawerOrModal
        mode="modal"
        open={budgetQtyFormularOpen}
        loading={qtyFormularLoading}
        onCancel={() => setBudgetQtyFormularOpen(false)}
        styles={{ body: { padding: '0 15px' } }}
        onOk={onBudgetQtyFormularSubmit}
        width={400}
        title="预算量"
      >
        <SGeneralForms
          ref={budgetQtyFormularRef}
          layout={'vertical'}
          configs={[
            {
              formItem: [
                {
                  label: '预算量计算式',
                  name: 'budgetQtyFormular',
                  spanCol: 24,
                },
                {
                  label: '备注',
                  name: 'remark',
                  spanCol: 24,
                },
              ],
            },
          ]}
        />
      </SDrawerOrModal>
    </Spin>
  )
}
